/* pdp-size-chart-v2.js
   Upload this as a Shopify asset:
   Assets > Add a new asset > Create a blank file > pdp-size-chart-v2.js
*/
(function () {
  'use strict';

  function initAll(root) {
    root = root || document;
    var modals = root.querySelectorAll('[data-size-chart-modal]');
    modals.forEach(function (modal) {
      initModal(modal);
    });
  }

  function initModal(sizeChartModal) {
    if (!sizeChartModal || sizeChartModal.getAttribute('data-size-chart-ready') === 'true') return;
    sizeChartModal.setAttribute('data-size-chart-ready', 'true');

    var modalId = sizeChartModal.id || '';
    var sectionId = modalId.replace('pdp-size-chart-modal-', '');
    var sizeChartDrawer = sizeChartModal.querySelector('.pdp-size-chart-drawer');
    var sizeChartDataEl = document.getElementById('PdpSizeChartData-' + sectionId) || sizeChartModal.querySelector('script[type="application/json"]');
    var sizeChartPayload = readSizeChartPayload(sizeChartDataEl);
    var sizeChartConfig = resolveSizeChartConfig(sizeChartPayload);
    var sizeChartState = {
      country: normalizeCode(sizeChartConfig.default_country || sizeChartModal.getAttribute('data-default-country') || 'US'),
      unit: String(sizeChartConfig.default_unit || sizeChartModal.getAttribute('data-default-unit') || 'in').toLowerCase(),
      length: normalizeCode(sizeChartConfig.default_length || sizeChartModal.getAttribute('data-default-length') || 'full').toLowerCase()
    };

    function openSizeChartModal(event) {
      if (event) event.preventDefault();
      sizeChartModal.classList.add('is-open');
      sizeChartModal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
      renderSizeChart();
      if (sizeChartDrawer) sizeChartDrawer.focus();
    }

    function closeSizeChartModal() {
      sizeChartModal.classList.remove('is-open');
      sizeChartModal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.body.style.overflow = '';
      closeCountryMenu();
    }

    function readSizeChartPayload(el) {
      if (!el) return {};
      try {
        return JSON.parse(el.textContent || '{}');
      } catch (error) {
        return { parse_error: error.message };
      }
    }

    function resolveSizeChartConfig(payload) {
      payload = payload || {};
      var data = payload.json_metafield || null;

      if (!data && payload.fallback_json) {
        try {
          data = typeof payload.fallback_json === 'string' ? JSON.parse(payload.fallback_json) : payload.fallback_json;
        } catch (error) {
          showSizeChartStatus('The fallback size chart JSON is invalid. The modal is using legacy/default table data.');
        }
      }

      if (!data || typeof data !== 'object') {
        data = buildLegacySizeChartData(payload.legacy || {});
      }

      return normalizeSizeChartData(data, payload.legacy || {});
    }

    function buildLegacySizeChartData(legacy) {
      var defaultBody = [
        { size: 'XS', country_sizes: { US: '0 - 2', UK: '4 - 6', EU: '32 - 34', AU: '4 - 6' }, measurements: { full: { waist: { in: '25.5-26.5', cm: '65-67' }, hip: { in: '35-36', cm: '89-91' } }, '78': { waist: { in: '25.5-26.5', cm: '65-67' }, hip: { in: '35-36', cm: '89-91' } } } },
        { size: 'S', country_sizes: { US: '4 - 6', UK: '8 - 10', EU: '36 - 38', AU: '8 - 10' }, measurements: { full: { waist: { in: '27-28', cm: '69-71' }, hip: { in: '36.5-37.5', cm: '93-95' } }, '78': { waist: { in: '27-28', cm: '69-71' }, hip: { in: '36.5-37.5', cm: '93-95' } } } },
        { size: 'M', country_sizes: { US: '8 - 10', UK: '12 - 14', EU: '40 - 42', AU: '12 - 14' }, measurements: { full: { waist: { in: '28.5-30.5', cm: '72-77' }, hip: { in: '38-40', cm: '97-102' } }, '78': { waist: { in: '28.5-30.5', cm: '72-77' }, hip: { in: '38-40', cm: '97-102' } } } },
        { size: 'L', country_sizes: { US: '12 - 14', UK: '16 - 18', EU: '44 - 46', AU: '16 - 18' }, measurements: { full: { waist: { in: '31-33.5', cm: '79-85' }, hip: { in: '40.5-43', cm: '103-109' } }, '78': { waist: { in: '31-33.5', cm: '79-85' }, hip: { in: '40.5-43', cm: '103-109' } } } },
        { size: 'XL', country_sizes: { US: '16', UK: '20', EU: '48', AU: '20' }, measurements: { full: { waist: { in: '34-36.5', cm: '86-93' }, hip: { in: '43.5-46', cm: '110-117' } }, '78': { waist: { in: '34-36.5', cm: '86-93' }, hip: { in: '43.5-46', cm: '110-117' } } } }
      ];

      var defaultProduct = [
        { size: 'XS', measurements: { full: { inseam: { in: '28', cm: '71' }, outseam: { in: '37', cm: '94' } }, '78': { inseam: { in: '25', cm: '63.5' }, outseam: { in: '34', cm: '86' } } } },
        { size: 'S', measurements: { full: { inseam: { in: '28', cm: '71' }, outseam: { in: '37.5', cm: '95' } }, '78': { inseam: { in: '25', cm: '63.5' }, outseam: { in: '34.5', cm: '87.5' } } } },
        { size: 'M', measurements: { full: { inseam: { in: '28', cm: '71' }, outseam: { in: '38', cm: '96.5' } }, '78': { inseam: { in: '25', cm: '63.5' }, outseam: { in: '35', cm: '89' } } } },
        { size: 'L', measurements: { full: { inseam: { in: '28', cm: '71' }, outseam: { in: '38', cm: '96.5' } }, '78': { inseam: { in: '25', cm: '63.5' }, outseam: { in: '35.5', cm: '90' } } } },
        { size: 'XL', measurements: { full: { inseam: { in: '28', cm: '71' }, outseam: { in: '38.5', cm: '98' } }, '78': { inseam: { in: '25', cm: '63.5' }, outseam: { in: '36', cm: '91.5' } } } }
      ];

      return {
        title: legacy.title || 'Size Chart',
        default_country: legacy.default_country || 'US',
        default_unit: legacy.default_unit || 'in',
        default_length: legacy.default_length || 'full',
        countries_string: legacy.countries_string,
        lengths_string: legacy.lengths_string,
        body_title: 'Body Measurements',
        body_note: legacy.body_note || 'These measurements reflect body circumference ranges for each size.',
        product_title: 'Product Measurements',
        product_note: legacy.product_note || 'These measurements reflect manual measurements of the garment.',
        body_measurements: legacy.body_measurements || defaultBody,
        product_measurements: legacy.product_measurements || defaultProduct,
        model_fit: legacy.model_fit || {},
        how_to_measure: legacy.how_to_measure || {}
      };
    }

    function normalizeSizeChartData(data, legacy) {
      data = data || {};
      if (!Array.isArray(data.countries)) {
        data.countries = parseOptionString(data.countries_string || legacy.countries_string, [
          { label: 'US SIZE', code: 'US' },
          { label: 'UK SIZE', code: 'UK' },
          { label: 'EU SIZE', code: 'EU' },
          { label: 'AU SIZE', code: 'AU' }
        ]);
      }

      if (!Array.isArray(data.lengths)) {
        data.lengths = parseOptionString(data.lengths_string || legacy.lengths_string, [
          { label: 'Full Length', code: 'full' },
          { label: '7/8 Length', code: '78' }
        ]);
      }

      data.default_country = normalizeCode(data.default_country || legacy.default_country || 'US');
      data.default_unit = String(data.default_unit || legacy.default_unit || 'in').toLowerCase();
      data.default_length = normalizeCode(data.default_length || legacy.default_length || 'full').toLowerCase();

      if (!data.body_title) data.body_title = 'Body Measurements';
      if (!data.product_title) data.product_title = 'Product Measurements';
      if (!data.model_title) data.model_title = 'Model Fit';
      if (!data.measure_title) data.measure_title = 'How To Measure';
      if (!Array.isArray(data.body_measurements)) data.body_measurements = [];
      if (!Array.isArray(data.product_measurements)) data.product_measurements = [];
      if (!data.model_fit) data.model_fit = {};
      if (!data.how_to_measure) data.how_to_measure = {};
      return data;
    }

    function parseOptionString(optionString, fallback) {
      if (!optionString || typeof optionString !== 'string') return fallback;
      var options = optionString.split(',').map(function (item) {
        var parts = item.split('|');
        var label = (parts[0] || '').trim();
        var code = (parts[1] || parts[0] || '').trim();
        if (!label || !code) return null;
        return { label: label, code: code };
      }).filter(Boolean);
      return options.length ? options : fallback;
    }

    function normalizeCode(value) {
      return String(value || '').trim().replace(/\s+/g, '_');
    }

    function getCountryLabel(code) {
      code = normalizeCode(code).toUpperCase();
      for (var i = 0; i < sizeChartConfig.countries.length; i += 1) {
        if (normalizeCode(sizeChartConfig.countries[i].code).toUpperCase() === code) return sizeChartConfig.countries[i].label;
      }
      return code + ' SIZE';
    }

    function getCountrySize(row) {
      var country = normalizeCode(sizeChartState.country).toUpperCase();
      var lower = country.toLowerCase();
      return firstValue([
        row.country_sizes && row.country_sizes[country],
        row.country_sizes && row.country_sizes[lower],
        row[country + '_size'],
        row[lower + '_size'],
        row[lower],
        row.us_size,
        row.us,
        row.country_size
      ]);
    }

    function getMeasurement(row, lengthCode, key, unit) {
      if (!row) return '';
      var normalizedLength = normalizeCode(lengthCode || sizeChartState.length).toLowerCase();
      var normalizedUnit = String(unit || sizeChartState.unit || 'in').toLowerCase();
      var normalizedKey = key === 'hip' ? 'hip' : key;
      var direct = null;

      if (row.measurements) {
        var lengthBucket = row.measurements[normalizedLength] || row.measurements[normalizedLength.toUpperCase()] || row.measurements.full || row.measurements.default;
        if (lengthBucket) {
          direct = getMeasurementValue(lengthBucket[normalizedKey] || lengthBucket[normalizedKey + 's'], normalizedUnit);
          if (direct) return direct;
        }
      }

      if (row[normalizedLength]) {
        direct = getMeasurementValue(row[normalizedLength][normalizedKey] || row[normalizedLength][normalizedKey + 's'], normalizedUnit);
        if (direct) return direct;
      }

      var flatCandidates = [
        row[normalizedLength + '_' + normalizedKey + '_' + normalizedUnit],
        row[normalizedKey + '_' + normalizedLength + '_' + normalizedUnit],
        row[normalizedLength + '_' + normalizedKey],
        row[normalizedKey + '_' + normalizedLength],
        row[normalizedKey + '_' + normalizedUnit],
        row[normalizedKey + 's_' + normalizedUnit],
        row[normalizedKey],
        row[normalizedKey + 's']
      ];

      if (normalizedKey === 'outseam') {
        flatCandidates.push(row.length_cm && normalizedUnit === 'cm' ? row.length_cm : '');
        flatCandidates.push(row.length);
      }

      return firstValue(flatCandidates);
    }

    function getMeasurementValue(value, unit) {
      if (value == null || value === '') return '';
      if (typeof value === 'object') {
        return firstValue([value[unit], value[String(unit).toUpperCase()], value.value, value.in, value.cm]);
      }
      return value;
    }

    function firstValue(values) {
      for (var i = 0; i < values.length; i += 1) {
        if (values[i] !== undefined && values[i] !== null && values[i] !== '') return values[i];
      }
      return '';
    }

    function escapeHtml(value) {
      return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
        return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[char];
      });
    }

    function showSizeChartStatus(message) {
      var status = sizeChartModal.querySelector('[data-size-chart-status]');
      if (!status) return;
      if (!message) {
        status.hidden = true;
        status.textContent = '';
        return;
      }
      status.hidden = false;
      status.textContent = message;
    }

    function renderSizeChart() {
      showSizeChartStatus('');
      renderCountrySelector();
      renderLengthControls();
      renderBodyTable();
      renderProductTable();
      renderModelFit();
      renderHowToMeasure();
      updateActiveControls();
    }

    function renderCountrySelector() {
      var menu = sizeChartModal.querySelector('[data-size-chart-country-menu]');
      if (!menu) return;
      menu.innerHTML = sizeChartConfig.countries.map(function (country) {
        var code = normalizeCode(country.code);
        return '<button type="button" class="pdp-size-chart-country-option" role="option" data-size-chart-country-option="' + escapeHtml(code) + '" aria-selected="false">' + escapeHtml(country.label) + '</button>';
      }).join('');
    }

    function renderLengthControls() {
      sizeChartModal.querySelectorAll('[data-size-chart-length-controls]').forEach(function (group) {
        group.innerHTML = sizeChartConfig.lengths.map(function (length) {
          var code = normalizeCode(length.code).toLowerCase();
          return '<button type="button" class="pdp-size-chart-length-btn" data-size-chart-length="' + escapeHtml(code) + '" aria-pressed="false">' + escapeHtml(length.label) + '</button>';
        }).join('');
      });
    }

    function renderBodyTable() {
      var section = sizeChartModal.querySelector('[data-size-chart-section="body"]');
      var container = sizeChartModal.querySelector('[data-size-chart-body-table]');
      var note = sizeChartModal.querySelector('[data-size-chart-body-note]');
      var title = sizeChartModal.querySelector('[data-size-chart-body-title]');
      var show = sizeChartModal.getAttribute('data-show-body') !== 'false';
      if (section) section.style.display = show ? '' : 'none';
      if (!show || !container) return;

      if (title) title.textContent = sizeChartConfig.body_title || 'Body Measurements';
      var rows = sizeChartConfig.body_measurements || [];

      if (!rows.length) {
        var htmlTemplate = sizeChartModal.querySelector('[data-size-chart-body-html]');
        container.innerHTML = htmlTemplate && htmlTemplate.innerHTML.trim() ? htmlTemplate.innerHTML : '<div class="pdp-size-chart-empty">Add body measurement rows in the size chart JSON metafield.</div>';
        if (note) note.textContent = '';
        return;
      }

      var unitLabel = sizeChartState.unit === 'cm' ? 'cm' : 'in';
      var html = '<table class="pdp-size-chart-table" aria-label="Body measurements size chart"><thead><tr>' +
        '<th scope="col">Size</th>' +
        '<th scope="col">' + escapeHtml(getCountryLabel(sizeChartState.country)) + '</th>' +
        '<th scope="col">Waist (' + unitLabel + ')</th>' +
        '<th scope="col">Hip (' + unitLabel + ')</th>' +
        '</tr></thead><tbody>';

      rows.forEach(function (row) {
        html += '<tr>' +
          '<td>' + escapeHtml(row.size || row.label || '') + '</td>' +
          '<td>' + escapeHtml(getCountrySize(row)) + '</td>' +
          '<td>' + escapeHtml(getMeasurement(row, sizeChartState.length, 'waist', sizeChartState.unit)) + '</td>' +
          '<td>' + escapeHtml(getMeasurement(row, sizeChartState.length, 'hip', sizeChartState.unit)) + '</td>' +
          '</tr>';
      });

      html += '</tbody></table>';
      container.innerHTML = html;
      if (note) note.textContent = sizeChartConfig.body_note || 'These measurements reflect body circumference ranges for each size.';
    }

    function renderProductTable() {
      var section = sizeChartModal.querySelector('[data-size-chart-section="product"]');
      var container = sizeChartModal.querySelector('[data-size-chart-product-table]');
      var note = sizeChartModal.querySelector('[data-size-chart-product-note]');
      var title = sizeChartModal.querySelector('[data-size-chart-product-title]');
      var show = sizeChartModal.getAttribute('data-show-product') !== 'false';
      if (section) section.style.display = show ? '' : 'none';
      if (!show || !container) return;

      if (title) title.textContent = sizeChartConfig.product_title || 'Product Measurements';
      var rows = sizeChartConfig.product_measurements || [];

      if (!rows.length) {
        var htmlTemplate = sizeChartModal.querySelector('[data-size-chart-product-html]');
        container.innerHTML = htmlTemplate && htmlTemplate.innerHTML.trim() ? htmlTemplate.innerHTML : '<div class="pdp-size-chart-empty">Add product measurement rows in the size chart JSON metafield.</div>';
        if (note) note.textContent = '';
        return;
      }

      var unitLabel = sizeChartState.unit === 'cm' ? 'cm' : 'in';
      var html = '<table class="pdp-size-chart-table" aria-label="Product measurements size chart"><thead><tr>' +
        '<th scope="col">Size</th>' +
        '<th scope="col">Inseam (' + unitLabel + ')</th>' +
        '<th scope="col">Outseam (' + unitLabel + ')</th>' +
        '</tr></thead><tbody>';

      rows.forEach(function (row) {
        html += '<tr>' +
          '<td>' + escapeHtml(row.size || row.label || '') + '</td>' +
          '<td>' + escapeHtml(getMeasurement(row, sizeChartState.length, 'inseam', sizeChartState.unit)) + '</td>' +
          '<td>' + escapeHtml(getMeasurement(row, sizeChartState.length, 'outseam', sizeChartState.unit)) + '</td>' +
          '</tr>';
      });

      html += '</tbody></table>';
      container.innerHTML = html;
      if (note) note.textContent = sizeChartConfig.product_note || 'These measurements reflect manual measurements of the garment.';
    }

    function renderModelFit() {
      var section = sizeChartModal.querySelector('[data-size-chart-section="model"]');
      var container = sizeChartModal.querySelector('[data-size-chart-model-fit]');
      var title = sizeChartModal.querySelector('[data-size-chart-model-title]');
      var show = sizeChartModal.getAttribute('data-show-model') !== 'false';
      if (section) section.style.display = show ? '' : 'none';
      if (!show || !container) return;

      var model = sizeChartConfig.model_fit || {};
      var details = model.details || model.measurements || {};
      var models = Array.isArray(model.models) ? model.models : [];
      if (title) title.textContent = sizeChartConfig.model_title || 'Model Fit';

      var detailHtml = '';
      ['bust', 'waist', 'hip'].forEach(function (key) {
        var label = key === 'hip' ? 'Hip' : key.charAt(0).toUpperCase() + key.slice(1);
        var value = getMeasurementValue(details[key] || details[key + 's'], sizeChartState.unit);
        if (value) detailHtml += '<span>' + label + ': <strong>' + escapeHtml(value) + ' ' + escapeHtml(sizeChartState.unit) + '</strong></span>';
      });
      if (details.size_worn || details.size) detailHtml += '<span>Size worn: <strong>' + escapeHtml(details.size_worn || details.size) + '</strong></span>';

      var imageHtml = model.image ? '<img src="' + escapeHtml(model.image) + '" alt="' + escapeHtml(model.image_alt || 'Model fit') + '" loading="lazy">' : '<div class="pdp-size-chart-model-placeholder"></div>';

      var html = '<div class="pdp-size-chart-model-card">' +
        '<div class="pdp-size-chart-model-image">' + imageHtml + '</div>' +
        '<div class="pdp-size-chart-model-content">' +
        '<div class="pdp-size-chart-model-title">' + escapeHtml(model.title || model.text || 'Model is 5 ft 8 in, wearing: S') + '</div>' +
        (detailHtml ? '<div class="pdp-size-chart-model-details">' + detailHtml + '</div>' : '') +
        '</div>' +
        '</div>';

      if (models.length) {
        html += '<div class="pdp-size-chart-model-table-wrap" data-size-chart-model-table-wrap>' +
          '<table class="pdp-size-chart-table pdp-size-chart-model-table" aria-label="Model fit measurements">' +
          '<thead><tr><th scope="col">Name</th><th scope="col">Size</th><th scope="col">Bust (' + escapeHtml(sizeChartState.unit) + ')</th><th scope="col">Waist (' + escapeHtml(sizeChartState.unit) + ')</th><th scope="col">Hip (' + escapeHtml(sizeChartState.unit) + ')</th></tr></thead><tbody>';

        models.forEach(function (modelRow) {
          html += '<tr>' +
            '<td>' + escapeHtml(modelRow.name || '') + '</td>' +
            '<td>' + escapeHtml(modelRow.size || modelRow.size_worn || '') + '</td>' +
            '<td>' + escapeHtml(getMeasurementValue(modelRow.bust, sizeChartState.unit)) + '</td>' +
            '<td>' + escapeHtml(getMeasurementValue(modelRow.waist, sizeChartState.unit)) + '</td>' +
            '<td>' + escapeHtml(getMeasurementValue(modelRow.hip || modelRow.hips, sizeChartState.unit)) + '</td>' +
            '</tr>';
        });

        html += '</tbody></table></div>' +
          '<button type="button" class="pdp-size-chart-view-more" data-size-chart-view-more>View More <span aria-hidden="true">⌄</span></button>';
      }

      container.innerHTML = html;
    }

    function renderHowToMeasure() {
      var section = sizeChartModal.querySelector('[data-size-chart-section="measure"]');
      var container = sizeChartModal.querySelector('[data-size-chart-how-to-measure]');
      var title = sizeChartModal.querySelector('[data-size-chart-measure-title]');
      var show = sizeChartModal.getAttribute('data-show-measure') !== 'false';
      if (section) section.style.display = show ? '' : 'none';
      if (!show || !container) return;

      var measure = sizeChartConfig.how_to_measure || {};
      if (title) title.textContent = sizeChartConfig.measure_title || 'How To Measure';

      var bodyTips = Array.isArray(measure.body_tips) ? measure.body_tips : [
        { title: 'Waist', copy: 'Measure around your natural waist, the narrowest part of your torso.' },
        { title: 'Hips', copy: 'Stand with feet together and measure around the fullest part of your hips, keeping the tape level.' }
      ];
      var productTips = Array.isArray(measure.product_tips) ? measure.product_tips : [
        { title: 'Outseam', copy: 'Measure from the top of the waistband down the side seam to the hem.' },
        { title: 'Inseam', copy: 'Measure from the crotch seam to the bottom hem.' }
      ];

      container.innerHTML = renderMeasureCard(measure.body_image, 'How to measure waist and hips', bodyTips, measure.body_copy_html) +
        renderMeasureCard(measure.product_image, 'How to measure inseam and outseam', productTips, measure.product_copy_html);
    }

    function renderMeasureCard(image, alt, tips, htmlCopy) {
      var imageHtml = image ? '<img src="' + escapeHtml(image) + '" alt="' + escapeHtml(alt) + '" loading="lazy">' : '<div class="pdp-size-chart-measure-placeholder"></div>';
      var copyHtml = htmlCopy || tips.map(function (tip) {
        return '<div class="pdp-size-chart-measure-copy-item"><h4>' + escapeHtml(tip.title) + '</h4><p>' + escapeHtml(tip.copy) + '</p></div>';
      }).join('');

      return '<div class="pdp-size-chart-measure-card">' +
        '<div class="pdp-size-chart-measure-image">' + imageHtml + '</div>' +
        '<div class="pdp-size-chart-measure-copy">' + copyHtml + '</div>' +
        '</div>';
    }

    function updateActiveControls() {
      sizeChartModal.querySelectorAll('.pdp-size-chart-unit-btn').forEach(function (btn) {
        var isActive = String(btn.getAttribute('data-size-chart-unit') || '').toLowerCase() === sizeChartState.unit;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      sizeChartModal.querySelectorAll('.pdp-size-chart-length-btn').forEach(function (btn) {
        var isActive = normalizeCode(btn.getAttribute('data-size-chart-length')).toLowerCase() === sizeChartState.length;
        btn.classList.toggle('active', isActive);
        btn.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });

      var currentCountry = sizeChartModal.querySelector('[data-size-chart-country-current]');
      if (currentCountry) currentCountry.textContent = getCountryLabel(sizeChartState.country);

      sizeChartModal.querySelectorAll('[data-size-chart-country-option]').forEach(function (option) {
        var isActive = normalizeCode(option.getAttribute('data-size-chart-country-option')).toUpperCase() === normalizeCode(sizeChartState.country).toUpperCase();
        option.classList.toggle('active', isActive);
        option.setAttribute('aria-selected', isActive ? 'true' : 'false');
      });
    }

    function closeCountryMenu() {
      var trigger = sizeChartModal.querySelector('[data-size-chart-country-trigger]');
      var menu = sizeChartModal.querySelector('[data-size-chart-country-menu]');
      if (trigger) trigger.setAttribute('aria-expanded', 'false');
      if (menu) menu.hidden = true;
    }

    var triggerSelector = '[aria-controls="' + modalId + '"], [data-size-chart-open="' + sectionId + '"]';
    document.querySelectorAll(triggerSelector).forEach(function (trigger) {
      trigger.addEventListener('click', openSizeChartModal);
    });

    sizeChartModal.querySelectorAll('[data-size-chart-close]').forEach(function (closeBtn) {
      closeBtn.addEventListener('click', closeSizeChartModal);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && sizeChartModal.classList.contains('is-open')) {
        closeSizeChartModal();
      }
    });

    document.addEventListener('click', function (event) {
      if (!sizeChartModal.contains(event.target)) return;

      var countryTrigger = event.target.closest('[data-size-chart-country-trigger]');
      var countryOption = event.target.closest('[data-size-chart-country-option]');
      var unitBtn = event.target.closest('.pdp-size-chart-unit-btn');
      var lengthBtn = event.target.closest('.pdp-size-chart-length-btn');
      var viewMoreBtn = event.target.closest('[data-size-chart-view-more]');

      if (countryTrigger) {
        var menu = sizeChartModal.querySelector('[data-size-chart-country-menu]');
        var expanded = countryTrigger.getAttribute('aria-expanded') === 'true';
        countryTrigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (menu) menu.hidden = expanded;
        return;
      }

      if (countryOption) {
        sizeChartState.country = normalizeCode(countryOption.getAttribute('data-size-chart-country-option'));
        closeCountryMenu();
        renderBodyTable();
        updateActiveControls();
        return;
      }

      if (unitBtn) {
        sizeChartState.unit = String(unitBtn.getAttribute('data-size-chart-unit') || 'in').toLowerCase();
        renderBodyTable();
        renderProductTable();
        renderModelFit();
        updateActiveControls();
        return;
      }

      if (lengthBtn) {
        sizeChartState.length = normalizeCode(lengthBtn.getAttribute('data-size-chart-length')).toLowerCase();
        renderBodyTable();
        renderProductTable();
        updateActiveControls();
        return;
      }

      if (viewMoreBtn) {
        var tableWrap = sizeChartModal.querySelector('[data-size-chart-model-table-wrap]');
        if (!tableWrap) return;
        var open = tableWrap.classList.toggle('is-open');
        viewMoreBtn.innerHTML = open ? 'View Less <span aria-hidden="true">⌃</span>' : 'View More <span aria-hidden="true">⌄</span>';
      }
    });

    renderSizeChart();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
